import React, { useState } from 'react';
import CropTypeAdmin from './CropTypeAdmin';
import VarietyAdmin from './VarietyAdmin';
import GrowthPhaseAdmin from './GrowthPhaseAdmin';

const AdminBiologyMenu = () => {
    const [activeTab, setActiveTab] = useState('cropTypes');

    return (
        <div className="flex flex-col min-h-screen bg-gray-50">
            {/* Header section with Tabs - Matching MyCropFollowUp style */}
            <div className="bg-white border-b border-gray-200 px-4 md:px-8 shadow-sm">
                <div className="max-w-7xl mx-auto">
                    <div className="py-4">
                        <h1 className="text-3xl font-semibold text-blue-600">Configuración Biológica</h1>
                    </div>
                    
                    <div className="flex gap-6 overflow-x-auto">
                        {[
                            { id: 'cropTypes', label: 'Tipos de Cultivo', icon: 'category' },
                            { id: 'varieties', label: 'Variedades', icon: 'grass' },
                            { id: 'phases', label: 'Etapas Fenológicas', icon: 'timeline' },
                        ].map((tab) => (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`
                                    flex items-center py-4 px-2 border-b-2 font-medium text-sm transition-colors whitespace-nowrap
                                    ${activeTab === tab.id
                                        ? 'border-green-600 text-green-700'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}
                                `}
                            >
                                <span className="material-icons-outlined mr-2 text-lg">{tab.icon}</span>
                                {tab.label}
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            {/* Main Content section */}
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-8 w-full">
                <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
                    {activeTab === 'cropTypes' && <CropTypeAdmin />}
                    {activeTab === 'varieties' && <VarietyAdmin />}
                    {activeTab === 'phases' && <GrowthPhaseAdmin />}
                </div>
            </div>
        </div>
    );
};

export default AdminBiologyMenu;
